export default function render({
  id,
  address,
  planName,
  squareFeet,
  bathrooms,
  bedrooms,
  garages,
  price,
  imageUrl,
  isChecked = false,
  isDisabled = false
}) {
  return `<div data-self-guided-tour-card data-spec-id="${id}" class="nhs-c-card--housing nhs-c-card--utour nhs-mq-card--utour-medium">
        <picture class="nhs-c-image--height-1480 nhs-mq-image--width-2100-medium">
            <source srcset="${imageUrl}?maxwidth=296&amp;format=webp&amp;progressive=true 296w,${imageUrl}?maxwidth=334&amp;format=webp&amp;progressive=true 334w,${imageUrl}?maxwidth=592&amp;format=webp&amp;progressive=true 592w,${imageUrl}?maxwidth=668&amp;format=webp&amp;progressive=true 668w" data-srcset="${imageUrl}?maxwidth=296&amp;format=webp&amp;progressive=true 296w,${imageUrl}?maxwidth=334&amp;format=webp&amp;progressive=true 334w,${imageUrl}?maxwidth=592&amp;format=webp&amp;progressive=true 592w,${imageUrl}?maxwidth=668&amp;format=webp&amp;progressive=true 668w" data-lazy-load="" type="image/webp" sizes="(max-width: 975px) 334px, 296px">
            <source srcset="${imageUrl}?maxwidth=296&amp;format=jpg&amp;progressive=true 296w,${imageUrl}?maxwidth=334&amp;format=jpg&amp;progressive=true 334w,${imageUrl}?maxwidth=592&amp;format=jpg&amp;progressive=true 592w,${imageUrl}?maxwidth=668&amp;format=jpg&amp;progressive=true 668w" data-srcset="${imageUrl}?maxwidth=296&amp;format=jpg&amp;progressive=true 296w,${imageUrl}?maxwidth=334&amp;format=jpg&amp;progressive=true 334w,${imageUrl}?maxwidth=592&amp;format=jpg&amp;progressive=true 592w,${imageUrl}?maxwidth=668&amp;format=jpg&amp;progressive=true 668w" data-lazy-load="" type="image/jpeg" sizes="(max-width: 975px) 334px, 296px">
            <img class="nhs-c-image--height-1480 nhs-mq-image--width-2100-medium" src="${imageUrl}?maxwidth=296&amp;format=jpg&amp;progressive=true" data-on-error-src="https://beta-nhs-static-secure.akamaized.net/GlobalResources14/Default/images/no_images/home-card-no-photo.svg" alt="${address} (${planName})" sizes="(max-width: 975px) 334px, 296px">
        </picture>
        <div class="nhs-c-card__body nhs-u-flex--1-1-auto" data-qa="card_body">
            <div class="nhs-c-card__content nhs-c-card__content--utour">
                <div>
                    <p class="nhs-c-card__plan-name nhs_SpecPlanName">${planName}</p>
                    <p class="nhs-c-card__price" data-card-element="price">
                        <span data-qa="price_label">
                            From
                            <span>${price}</span>
                        </span>
                    </p>
                </div>
                <p class="nhs-c-card__facts" data-qa="card_specs">
                  ${bedrooms} Br | ${bathrooms} Ba | ${garages} Gr | ${squareFeet} sq ft
                </p>
                <h3 class="nhs-c-card__facts">${address}</h3>
                <p class="nhs-c-input__container--with-text nhs-mq-card__input-container--absolute-medium">
                    <input data-spec-id="${id}" class="nhs-c-input__check-box" id="tour-this-home__${id}" type="checkbox" 
                    ${isChecked ? 'checked' : ''}
                    ${isDisabled ? 'disabled' : ''} />
                    <label for="tour-this-home__${id}">
                        Tour this home
                    </label>
                </p>
            </div>
        </div>
    </div>`;
}
